<template>
  <div>
    <div
      class="br-date form-input size-full --data-format-right"
      v-bind:class="{ '--has-error': errorShown === true }"
    >
      <label class="form-label" data-tool-tip="true">
        <info-icon></info-icon>
      </label>
      <input
        name="interest-rate"
        v-bind:data-ri-filtername="filterName"
        data-ri-filtervalue="[name='interest-rate']"
        v-model="inputValue"
        v-on:focus="selectAll"
        v-on:blur="setDate($event.target.value)"
        v-on:keyup.enter="setDate($event.target.value)"
        class="gearbox-input"
      />
    </div>
    <span class="error-message date-input__error" v-if="errorShown === true">{{
      error
    }}</span>
  </div>
</template>
<style lang="scss">
@import '../../../sass/brcom/settings/_settings.theme-colors.scss';
.date-input__error {
  color: $theme-red-dark;
  font-family: 'Calibre-Regular', Arial, sans-serif;
}
</style>
<script>
import utils from './../../bankrate-utilities/index'
import eventHub from '../bankrate-events'
import moment from 'moment'
import infoIcon from '../legacy-components/rt-info.vue'

export default {
  components: {
    'info-icon': infoIcon
  },

  props: {
    value: {
      default: moment().format('MM/DD/YYYY'),
      type: String
    },
    title: {
      default: '',
      type: String
    },
    copy: {
      default: function() {
        return []
      },
      type: Array
    },
    error: {
      default: '',
      type: String
    },
    showError: {
      default: false,
      type: Boolean
    }
  },

  data: function() {
    return {
      inputValue: this.value,
      errorShown: this.showError
    }
  },

  computed: {
    filterName: function() {
      return utils.dataCollectorFormat(this.title.toLowerCase())
    }
  },

  methods: {
    setDate: function(date) {
      let currentDate = moment(date, 'MM/DD/YYYY')
      if (currentDate.isValid()) {
        this.errorShown = false
        this.inputValue = currentDate.format('MM/DD/YYYY')
        eventHub.$emit('dateInput::updated', currentDate)
      } else {
        this.errorShown = true
      }
    },

    selectAll: function(event) {
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function() {
        event.target.select()
      }, 0)
    }
  }
}
</script>
